export enum LorenDashboardCardsViewTypes {
  GRID = "GRID",
  ROW = "ROW",
  TABLE = "TABLE",
}
